import { render, staticRenderFns } from "./not_found.vue?vue&type=template&id=7584a85e&scoped=true"
import script from "./not_found.vue?vue&type=script&lang=js"
export * from "./not_found.vue?vue&type=script&lang=js"
import style0 from "./not_found.vue?vue&type=style&index=0&id=7584a85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7584a85e",
  null
  
)

export default component.exports